import React from "react";

import { UserAuth } from "../../context/AuthContext";
import SearchBar from "../../components/MemberManagement/SearchBar/SearchBar";
import MembersTable from "../../components/MemberManagement/MembersTable/MembersTable";
import strings from "../../locales/ro.json";
import InfoIcon from "@mui/icons-material/Info";
import MemberStatsModal from "../../components/MemberManagement/MemberStatsModal/MemberStatsModal";

import "./UserManagement.css";
import HeaderElement from "../../components/HeaderElement/HeaderElement";
import FloatingButton from "../../components/Buttons/FloatingButton/FloatingButton";
import { useNavigate } from "react-router-dom";
import LoadingCircle from "../../components/Global/LoadingCircle";
import { useApi } from "../../hooks/useApi";


const UserManagement = () => {
  const { user } = UserAuth();
  const { api } = useApi();
  const [users, setUsers] = React.useState([]);
  const [gotData,setGotData] = React.useState(false);
  const [showStatsModal, setShowStatsModal] = React.useState(false);
  const navigate = useNavigate()

  const backFunction = () => {
    navigate("/admin")
  }

  const fetchUsers = async () => {
    try {
      const result = await api("users", "GET");
      setUsers(result);
      setGotData(true);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  React.useEffect(() => {
    if (user.accessToken) {
      fetchUsers();
    }
  }, [user]);

  React.useEffect(() => {
    setFilteredUsers(users);
  }, [users]);

  const [filteredUsers, setFilteredUsers] = React.useState(users);

  const handleFilterChange = (event) => {
    setFilteredUsers((prevArr) => {
      let newArr = [];

      newArr = users.filter((element) => {
        let searchTerm = event.target.value.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return element["name"].toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(searchTerm);
      });
      return newArr;
    });
  };

  return (
    <div>
      <div className="userManagementContainer">
        <HeaderElement headerText={strings.usermanagement.title} />
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '15px' }}>
          <SearchBar
            handleChange={handleFilterChange}
          />
          <InfoIcon 
            onClick={() => setShowStatsModal(true)} 
            style={{ cursor: 'pointer', color: 'var(--dark-grey)', fontSize: '32px' }} 
            titleAccess={strings.usermanagement.statsModal.infoIconTooltip}
          />
        </div>
        <MemberStatsModal 
          open={showStatsModal} 
          onClose={() => setShowStatsModal(false)} 
          users={users} 
        />
        {users.length !== 0 && <MembersTable users={filteredUsers} onStatuteChange={fetchUsers} />}
        {users.length === 0 && <LoadingCircle/>}
      </div>
    </div>
  );
};

export default UserManagement;
